// extracted by mini-css-extract-plugin
module.exports = {"container":"OrdersSidenav_container__2XQEY","checkboxContainer":"OrdersSidenav_checkboxContainer__KKpsn","query":"OrdersSidenav_query__2f-7b"};